import { useMemo } from 'react';
import type { VirtualAppointmentDto } from '../../services/virtualAppointments';
import type { VirtualAppointmentDraft } from './virtualAppointmentDraft';
import { NO_SAVED_TRIGGERS, type SavedTriggers } from './virtualAppointmentTriggerAhead';
import { type VirtualAppointmentSummary } from '@odo/shared-ui/clinical/virtualAppointments/summary';
import {
    summaryFromDraft,
    summaryFromDto,
    type VirtualAppointmentTypeLabels
} from './virtualAppointmentSummary';

const NO_DRAFTS: VirtualAppointmentDraft[] = [];
const NO_LABELS: VirtualAppointmentTypeLabels = new Map();

// Saved VAs first (labelled from their DTO), then unsaved drafts (labelled from `draftLabels`).
export function useVirtualAppointmentSummaries(
    saved: VirtualAppointmentDto[],
    drafts: VirtualAppointmentDraft[] = NO_DRAFTS,
    draftLabels: VirtualAppointmentTypeLabels = NO_LABELS,
    savedTriggers: SavedTriggers = NO_SAVED_TRIGGERS
): VirtualAppointmentSummary[] {
    return useMemo(
        () => [
            ...saved.map((va) => summaryFromDto(va)),
            ...drafts.map((d) => summaryFromDraft(d, draftLabels, { savedTriggers }))
        ],
        [saved, drafts, draftLabels, savedTriggers]
    );
}
